import React, { useEffect, useRef, useState } from 'react';
import Table from '../../components/Table';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import translations from '../../translations/de';
import Button from '../../components/Button';
import { FaSearch, FaPlus, FaTrash, FaListAlt } from 'react-icons/fa';
import Paths from '../../constants/paths';
import Modal from '../../components/Modal';
import useModal from '../../customHooks/useModal';

const Webhooks = ({ store }) => {
    const history = useHistory();
    const [pendingDeleteId, setPendingDeleteId] = useState(null);
    const modalRef = useRef(null);
    const [modal, setModal] = useModal(false, modalRef);

    useEffect(() => {
        store.getSubscriptions();
    }, [store]);

    const goToDetail = (id) => history.push(`/webhooks/${id}`);
    const goToDeliveries = (id) => history.push(`/webhooks/${id}/deliveries`);

    return (
        <>
            <Button
                label={translations.webhook}
                onClick={() => {
                    store.selectSubscription(undefined);
                    history.push(Paths.NEW_WEBHOOK);
                }}
                style={{ marginLeft: '2.5%' }}
            >
                <FaPlus style={{ marginRight: '5px' }} />
            </Button>

            <Table
                tableName={translations.webhooks}
                columns={[
                    { Header: 'ID', accessor: 'id', Cell: ({ value }) => <div>{value}</div> },
                    {
                        Header: translations.name,
                        accessor: 'name',
                        Cell: ({ value }) => <div>{value}</div>,
                    },
                    {
                        Header: 'URL',
                        accessor: 'url',
                        Cell: ({ value }) => (
                            <div style={{ wordBreak: 'break-all' }}>{value}</div>
                        ),
                    },
                    {
                        Header: translations.event_types,
                        accessor: 'event_types',
                        Cell: ({ value }) => (
                            <div>{Array.isArray(value) ? value.join(', ') : ''}</div>
                        ),
                    },
                    {
                        Header: translations.is_active,
                        accessor: 'is_active',
                        Cell: ({ value }) => <div>{value ? '✓' : '—'}</div>,
                    },
                    {
                        Header: '',
                        accessor: 'action',
                        Cell: ({ row }) => (
                            <div>
                                <Button
                                    onClick={() => goToDetail(row.cells[0].value)}
                                    title={translations.show}
                                >
                                    <FaSearch />
                                </Button>
                                <Button
                                    onClick={() => goToDeliveries(row.cells[0].value)}
                                    title={translations.deliveries}
                                >
                                    <FaListAlt />
                                </Button>
                                <Button
                                    onClick={() => {
                                        setPendingDeleteId(row.cells[0].value);
                                        setModal(true);
                                    }}
                                    title={translations.delete}
                                >
                                    <FaTrash />
                                </Button>
                            </div>
                        ),
                    },
                ]}
                data={store.subscriptions.map(
                    ({ id, name, url, event_types, is_active }) => ({
                        id,
                        name,
                        url,
                        event_types: event_types ? [...event_types] : [],
                        is_active,
                    }),
                )}
            />

            {modal && (
                <Modal
                    title={translations.delete_webhook}
                    ref={modalRef}
                    onClose={() => setModal(false)}
                    maxWidth="400px"
                >
                    <p style={{ color: '#333', marginBottom: '20px' }}>
                        {`Are you sure you want to delete subscription #${pendingDeleteId}?`}
                    </p>
                    <div className="Modal-Controls">
                        <Button
                            label="Yes"
                            onClick={() => {
                                store.deleteSubscription(pendingDeleteId);
                                setPendingDeleteId(null);
                                setModal(false);
                            }}
                            style={{ width: '80px' }}
                        />
                        <Button
                            label="No"
                            onClick={() => setModal(false)}
                            style={{ width: '80px', marginLeft: '20px' }}
                        />
                    </div>
                </Modal>
            )}
        </>
    );
};

export default observer(Webhooks);
